import { Shield, ShieldCheck, BarChart3, FlaskConical } from "lucide-react";
import { AdminAPI } from "@shared/types/api";

// Staff roles, with the icon/colour used to indicate them across the admin UI.
export const ROLE_CONFIG: Record<
  AdminAPI.UserRole,
  { label: string; icon: typeof Shield; className: string }
> = {
  admin: { label: "Admin", icon: Shield, className: "text-red-400" },
  moderator: { label: "Moderator", icon: ShieldCheck, className: "text-blue-400" },
  analytics: { label: "Analytics", icon: BarChart3, className: "text-purple-400" },
  tester: { label: "Tester", icon: FlaskConical, className: "text-amber-400" },
};

export const ALL_ROLES = Object.keys(ROLE_CONFIG) as AdminAPI.UserRole[];
